module.exports = __webpack_public_path__ + "img/rope_Braid_4.8a896b40.png";